export default "__VITE_ASSET__QT4v5LDQ__"